import * as _ from 'lodash';

export const checkPermissions = (admin, userPermissions, allowedPermissions, clients, clientId) => {
  if (!admin && clientId) {
    const client = _.find(clients, (c) => c.clientId === clientId);

    if (!client) return false;

    const permissionNames = _.map(client.permissions, (p) => p.name);
    return allowedPermissions.some((r) => permissionNames.includes(r));
  }
  return admin || allowedPermissions.some((r) => userPermissions.includes(r));
};

export const filterClientsByPermissions = (admin, permissions, clients) => {
  if (admin) return clients;
  return _.filter(clients, (p) => {
    const clientUsers = Array.isArray(p && p.clientUsers) ? p.clientUsers : [];
    const clientUser = clientUsers.length > 0 && clientUsers[0];
    if (clientUser && clientUser.permissions && clientUser.permissions.some((perm) => permissions.includes(perm.permission.name))) {
      return p;
    }
  });
};
